<div class="validation-notes-dialog" *ngIf="note; else noBody">
  <section class="validation-notes-dialog__section validation-notes-dialog__issue">
    <header class="validation-notes-dialog__issue-head">
      <h3 class="validation-notes-dialog__section-title">Issue</h3>
      <div class="validation-notes-dialog__issue-pills">
        <span class="error-code-badge error-code-badge--severe">{{ ruleLabel }}</span>
        <span class="validation-notes-pill"
              *ngIf="category"
              [attr.data-category]="category">
          <span class="validation-notes-pill__dot" [attr.data-category]="category" aria-hidden="true"></span>
          {{ categoryLabel }}
        </span>
      </div>
    </header>
    <p class="validation-notes-dialog__issue-text">{{ issue }}</p>
  </section>

  <hr class="validation-notes-dialog__rule" />

  <section class="validation-notes-dialog__section" *ngIf="summarySegments.length">
    <h3 class="validation-notes-dialog__section-title">Summary</h3>
    <ng-container *ngFor="let seg of summarySegments">
      <p *ngIf="seg.kind === 'paragraph'" class="validation-notes-dialog__paragraph">{{ seg.text }}</p>
      <ul *ngIf="seg.kind === 'list'" class="validation-notes-dialog__list">
        <li *ngFor="let item of seg.items">{{ item }}</li>
      </ul>
    </ng-container>
  </section>

  <hr class="validation-notes-dialog__rule" *ngIf="summarySegments.length && detailSegments.length" />

  <section class="validation-notes-dialog__section" *ngIf="detailSegments.length">
    <h3 class="validation-notes-dialog__section-title">Detail</h3>
    <ng-container *ngFor="let seg of detailSegments">
      <p *ngIf="seg.kind === 'paragraph'" class="validation-notes-dialog__paragraph">{{ seg.text }}</p>
      <ul *ngIf="seg.kind === 'list'" class="validation-notes-dialog__list">
        <li *ngFor="let item of seg.items">{{ item }}</li>
      </ul>
    </ng-container>
  </section>

  <!-- Suggested question + Ask XatBot. The question is authored per error code
       to give XatBot the best chance of a helpful answer. -->
  <section class="validation-notes-dialog__xatbot" *ngIf="question">
    <svg width="0" height="0" aria-hidden="true" focusable="false" style="position: absolute;">
      <defs>
        <linearGradient id="validation-notes-xatbot-sparkle" x1="1.0625" y1="2.39063" x2="15.9375" y2="16.2031"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#F7AE42" />
          <stop offset="0.555826" stop-color="#E82A7F" />
          <stop offset="1" stop-color="#B9299E" />
        </linearGradient>
      </defs>
    </svg>
    <h3 class="validation-notes-dialog__section-title">Suggested question</h3>
    <p class="validation-notes-dialog__xatbot-question">{{ question }}</p>
    <button type="button" class="validation-notes-dialog__ask-xatbot" (click)="askXatBot()">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 17 17" fill="none">
        <path
          d="M10.8574 2.85547L12.75 2.125L13.4473 0.265625C13.4805 0.0996094 13.6465 0 13.8125 0C13.9453 0 14.1113 0.0996094 14.1445 0.265625L14.875 2.125L16.7344 2.85547C16.9004 2.88867 17 3.05469 17 3.1875C17 3.35352 16.9004 3.51953 16.7344 3.55273L14.875 4.25L14.1445 6.14258C14.1113 6.27539 13.9453 6.375 13.8125 6.375C13.6465 6.375 13.4805 6.27539 13.4473 6.14258L12.75 4.25L10.8574 3.55273C10.6914 3.51953 10.625 3.35352 10.625 3.1875C10.625 3.05469 10.6914 2.88867 10.8574 2.85547ZM8.5332 6.24219L12.3184 7.96875C12.5176 8.06836 12.6504 8.26758 12.6504 8.4668C12.6504 8.66602 12.5176 8.86523 12.3184 8.96484L8.5332 10.6914L6.80664 14.4766C6.70703 14.6758 6.50781 14.8086 6.30859 14.8086C6.10938 14.8086 5.91016 14.6758 5.84375 14.4766L4.08398 10.6914L0.298828 8.96484C0.0996094 8.86523 0 8.66602 0 8.4668C0 8.26758 0.0996094 8.06836 0.298828 7.96875L4.08398 6.24219L5.84375 2.45703C5.91016 2.25781 6.10938 2.125 6.30859 2.125C6.50781 2.125 6.70703 2.25781 6.80664 2.45703L8.5332 6.24219ZM13.4473 10.8906C13.4805 10.7246 13.6465 10.625 13.8125 10.625C13.9453 10.625 14.1113 10.7246 14.1445 10.8906L14.875 12.75L16.7344 13.4805C16.9004 13.5137 17 13.6797 17 13.8125C17 13.9785 16.9004 14.1445 16.7344 14.1777L14.875 14.875L14.1445 16.7676C14.1113 16.9004 13.9453 17 13.8125 17C13.6465 17 13.4805 16.9004 13.4473 16.7676L12.75 14.875L10.8574 14.1777C10.6914 14.1445 10.625 13.9785 10.625 13.8125C10.625 13.6797 10.6914 13.5137 10.8574 13.4805L12.75 12.75L13.4473 10.8906Z"
          fill="url(#validation-notes-xatbot-sparkle)" />
      </svg>
      Ask XatBot
    </button>
  </section>
</div>

<ng-template #noBody>
  <p class="validation-notes-dialog__empty">No validation note is published for this rule.</p>
</ng-template>
